import React from 'react';
import Icon from '../../../components/AppIcon';

const FilamentStats = ({ filaments }) => {
  const totalFilaments = filaments?.length;
  const totalValue = filaments?.reduce((sum, f) => sum + (f?.currentWeight / f?.originalWeight) * f?.totalCost, 0);
  const totalWeight = filaments?.reduce((sum, f) => sum + f?.currentWeight, 0);
  const lowStockCount = filaments?.filter(f => (f?.currentWeight / f?.originalWeight) * 100 <= 20)?.length;
  
  const averageCostPerGram = totalWeight > 0 ? totalValue / totalWeight : 0;

  const stats = [
    {
      label: 'Total de Filamentos',
      value: totalFilaments?.toString(),
      icon: 'Package',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Valor Total do Estoque',
      value: `R$ ${totalValue?.toFixed(2)}`,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Peso Total Disponível',
      value: `${(totalWeight / 1000)?.toFixed(1)}kg`,
      icon: 'Weight',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      label: 'Filamentos com Estoque Baixo',
      value: lowStockCount?.toString(),
      icon: 'AlertTriangle',
      color: lowStockCount > 0 ? 'text-warning' : 'text-muted-foreground',
      bgColor: lowStockCount > 0 ? 'bg-warning/10' : 'bg-muted/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-2xl p-6 hover:shadow-elevation-1 transition-shadow">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
              {index === 1 && totalWeight > 0 && (
                <p className="text-xs text-muted-foreground mt-1">
                  Média: R$ {averageCostPerGram?.toFixed(2)}/g
                </p>
              )}
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FilamentStats;